export default "__VITE_ASSET__CEYqZ_NM__"